import { Button, FormGroup, Modal, TextArea, TextInput } from "src/components";
import styles from "./ShareModal.module.scss";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const ShareModal = ({ created, product, onClose, isSubscription }: any) => {
  const navigate = useNavigate();
  const [choice, setChoice] = useState<"product" | "checkout">(
    product?.hasProductPage === "yes" ? "product" : "checkout"
  );
  const onCloseModal = () => {
    onClose
      ? onClose()
      : navigate("/products/" + product._id, { replace: true });
  };
  const me =
    localStorage.getItem("me") && JSON.parse(localStorage.getItem("me")!);

  const prodUrl =
    choice === "product"
      ? product.slug?.length > 0
        ? `https://${me.subdomain}.${process.env.REACT_APP_AUTH0_AUDIENCE}/${product.slug}`
        : `https://${me.subdomain}.${process.env.REACT_APP_AUTH0_AUDIENCE}/${product._id}`
      : product.slug?.length > 0
        ? product?.hasProductPage !== "yes"
          ? `https://${me.subdomain}.${process.env.REACT_APP_AUTH0_AUDIENCE}/${product.slug}`
          : `https://${me.subdomain}.${process.env.REACT_APP_AUTH0_AUDIENCE}/checkout?productId=${product._id}`
        : `https://${me.subdomain}.${process.env.REACT_APP_AUTH0_AUDIENCE}/checkout?productId=${product._id}`;

  const link = isSubscription
    ? `https://${me.subdomain}.${process.env.REACT_APP_AUTH0_AUDIENCE}/checkout?subscriptionId=${product._id}`
    : prodUrl;

  const title = isSubscription ? "Share subscription" : "Share product";

  const embedCode = `<script
      src="https://app.pocketsflow.com/pocketsflow-popup.js"
      data-subdomain="${me.subdomain}"
    ></script>`;

  const buttonCodeProduct = `<button
      onClick={() => {
        window.openPocketsflowCheckout({
          type: "product",
          productId: "${product._id}",
          subdomain: "${me.subdomain}",
          isDarkMode: true,
          onSuccess: (data) => {
            // success callback

            // in data you will get:
            // {
            //   email: "test@test.com",
            //   firstName: "John",
            //   lastName: "Doe",
            //   paymentIntentId: "1234567890", (we also send the paymentIntentId in the webhook order.completed)
            //   data: the payment intent data
            //   metadata: the webhook metadata object
            // }
            console.log("success", data);
          },
        });
      }}
    >
      Buy Product
    </button>`;

  const buttonCodeSubscription = `<button
      onClick={() => {
        window.openPocketsflowCheckout({
          type: "subscription",
          subscriptionId: "${product._id}",
          subdomain: "${me.subdomain}",
          isDarkMode: true,
          onSuccess: (data) => {
            // success callback

            // in data you will get:
            // {
            //   type: "success",
            //   setupIntentId: confirmed.setupIntent.id,
            //   data: confirmed.setupIntent,
            //   isSubscription: true,
            //   firstName,
            //   lastName,
            //   email,
            //   metadata: the webhook metadata object
            // }
            console.log("success", data);
          },
      Buy Subscription
    </button>`;

  const buttonCodeSubscriptionEmbed = `<button
      onClick={() => {
        window.openPocketsflowCheckout({
          type: "subscription",
          subscriptionId: "${product._id}",
          subdomain: "${me.subdomain}",
          embedDivId: "pocketsflow-checkout", // your div id
          isDarkMode: true,
          onSuccess: (data) => {
            // success callback

            // in data you will get:
            // {
            //   type: "success",
            //   setupIntentId: confirmed.setupIntent.id,
            //   data: confirmed.setupIntent,
            //   isSubscription: true,
            //   firstName,
            //   lastName,
            //   email,
            //   metadata: the webhook metadata object
            // }
            console.log("success", data);
          },
        });
      }}
    >
      Buy Subscription
    </button>
    <div id="pocketsflow-checkout"></div>
    `;

  const buttonCodeProductEmbed = `<button
      onClick={() => {
        window.openPocketsflowCheckout({
          type: "product",
          productId: "${product._id}",
          subdomain: "${me.subdomain}",
          embedDivId: "pocketsflow-checkout", // your div id
          isDarkMode: true,
          onSuccess: (data) => {
            // success callback

            // in data you will get:
            // {
            //   email: "test@test.com",
            //   firstName: "John",
            //   lastName: "Doe",
            //   paymentIntentId: "1234567890", (we also send the paymentIntentId in the webhook order.completed)
            //   data: the payment intent data
            //   metadata: the webhook metadata object
            // }
            console.log("success", data);
          },
        });
      }}
    >
      Buy Product
    </button>
    <div id="pocketsflow-checkout"></div>
    `;

  return (
    <Modal onClose={onCloseModal} title={title} noFooter>
      <div className={styles.shareModal}>
        {!isSubscription && (
          <div className={styles.tabs}>
            <div
              className={`${styles.tab} ${choice === "product" ? styles.active : ""
                } ${product?.hasProductPage !== "yes" ? styles.disabled : ""}`}
              onClick={() => setChoice("product")}
            >
              Product page
            </div>
            <div
              className={`${styles.tab} ${choice === "checkout" ? styles.active : ""
                }`}
              onClick={() => setChoice("checkout")}
            >
              Checkout page
            </div>
          </div>
        )}
        <div className={styles.shareModalContent}>
          <div className={styles.shareModalContentInner}>
            <div className={styles.deleteModalText}>
              Copy the link and share it with the world.
            </div>
            <div className={styles.copyLinkContainer}>
              <TextInput
                type="text"
                value={link}
                onChange={() => { }}
                name="copyLink"
                disabled
              />
              <Button
                variant="secondary"
                text="Copy link"
                onClick={() => {
                  // copy to clipboard
                  navigator.clipboard.writeText(link);
                  toast.success("copied");
                }}
              />
            </div>
          </div>
          <div className={styles.shareModalContentInner}>
            <div className={styles.deleteModalText}>
              Or, embed it on your website.{" "}
              <a
                target="_blank"
                href="https://helpcenter.pocketsflow.com/en/articles/11428790-embedding-the-checkout-page"
                rel="noopener noreferrer"
                style={{ color: "#007bff", textDecoration: "underline" }}
              >
                Learn more
              </a>
            </div>
            <div
              className={`${styles.copyLinkContainer} ${styles.embedContainer}`}
            >
              <FormGroup label="index.html script">
                <TextArea
                  value={embedCode}
                  onChange={() => { }}
                  name="embedCode"
                  disabled
                />
              </FormGroup>
              <Button
                variant="secondary"
                text="Copy script"
                onClick={() => {
                  // copy to clipboard
                  navigator.clipboard.writeText(embedCode);
                  toast.success("Script copied");
                }}
              />
            </div>
            <div
              className={`${styles.copyLinkContainer} ${styles.embedContainer}`}
            >
              <FormGroup label="Button to open checkout (as a popup)">
                <div className={styles.ta}>
                  <TextArea
                    value={
                      isSubscription ? buttonCodeSubscription : buttonCodeProduct
                    }
                    onChange={() => { }}
                    name="embedCode"
                    disabled
                  />
                </div>
              </FormGroup>
              <Button
                variant="secondary"
                text="Copy code"
                onClick={() => {
                  // copy to clipboard
                  navigator.clipboard.writeText(
                    isSubscription ? buttonCodeSubscription : buttonCodeProduct
                  );
                  toast.success("Button copied");
                }}
              />
            </div>
            <div
              className={`${styles.copyLinkContainer} ${styles.embedContainer}`}
            >
              <FormGroup label="Button to open checkout (as an embedded checkout)">
                <div className={styles.ta}>
                  <TextArea
                    value={
                      isSubscription
                        ? buttonCodeSubscriptionEmbed
                        : buttonCodeProductEmbed
                    }
                    onChange={() => { }}
                    name="embedCode"
                    disabled
                  />
                </div>
              </FormGroup>
              <Button
                variant="secondary"
                text="Copy code"
                onClick={() => {
                  // copy to clipboard
                  navigator.clipboard.writeText(
                    isSubscription
                      ? buttonCodeSubscriptionEmbed
                      : buttonCodeProductEmbed
                  );
                  toast.success("Button copied");
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ShareModal;
